"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileNameLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FileIcon = require("./FileIcon/FileIcon");
var _formFieldPropTypes = require("../../../../propTypes/formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FileNameLabel = _ref => {
  let {
    file,
    onFileRemove
  } = _ref;
  const {
    name
  } = file;
  const fullLength = name.length;
  const adjust = fullLength < 10 ? 0 : 3;
  const lastDot = name.lastIndexOf('.');
  const shortName = name.substring(0, lastDot);
  const extension = name.substring(lastDot + 1);
  const trimmedName = name.substring(0, lastDot - adjust);
  const endName = shortName.substring(lastDot - adjust);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FileIcon.FileIcon, {
    file: file,
    fileExtension: extension
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "fileNameTrimmer"
  }, /*#__PURE__*/_react.default.createElement("strong", null, trimmedName), /*#__PURE__*/_react.default.createElement("em", null, endName, ".", extension), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => onFileRemove(file),
    className: "button primary text_only"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, "Remove item"))));
};
exports.FileNameLabel = FileNameLabel;
FileNameLabel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  file: _propTypes.default.any,
  onFileRemove: _propTypes.default.func
};